<template>
  <Modal v-model:is-open="isOpen" class="change-lang-modal">
    <div
      class="flex w-full items-center justify-between border-b border-solid py-5"
    >
      <p class="text-size_6 font-bold">
        {{ $t("user.account.labels.change_lang_tab") }}
      </p>
      <button @click="handleClose">
        <CommonUIcons class="h-icon_size_5 w-icon_size_5" name="ic-x" />
      </button>
    </div>

    <p class="text-size_5 font-medium text-neutral-600">
      {{ $t("user.account.messages.change_lang") }}
    </p>

    <form class="flex flex-col gap-16" @submit.prevent="onSubmit">
      <RadioGroup
        name="lang"
        right-aligned
        :initial-value="currentLang"
        :options="languages"
      />

      <div
        class="flex w-full flex-col items-center justify-between gap-4 md:flex-row md:gap-6"
      >
        <Button
          class="w-full"
          :c_style="{ type: 'secondary' }"
          :label="$t('common.actions.close')"
          @click="handleClose"
        />

        <Button
          class="w-full"
          type="submit"
          :label="$t('common.actions.save')"
        />
      </div>
    </form>
  </Modal>
</template>

<script setup lang="ts">
import Modal from "~/components/common/Atom/Modal.vue";
import Button from "~/components/common/Atom/Button.vue";
import RadioGroup from "~/components/common/Molecule/RadioGroup.vue";
import type { RadioProps } from "~/types/schemas/common/Atom/radio";
import { useForm } from "vee-validate";

const isOpen = defineModel("isOpen", { default: false });

defineProps<{
  languages: RadioProps[];
  currentLang: string;
}>();

const emit = defineEmits<{
  save: [lang: string];
  close: [];
}>();

const { handleSubmit } = useForm();

const handleClose = () => {
  isOpen.value = false;
  emit("close");
};

const onSubmit = handleSubmit((value: any) => {
  emit("save", value.lang as string);
});
</script>

<style>
.change-lang-modal {
  .modal-content {
    @apply flex flex-col gap-12 pb-12 pt-6;
  }
}
</style>
